import * as React from "react"
import { ImpersonationBanner } from "@/components/ImpersonationBanner"
import { MainNav } from "@/components/MainNav"

export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-page text-ink-body">
      <ImpersonationBanner />
      <div className="flex min-h-0 flex-1">
        <MainNav />
        <main className="min-w-0 flex-1 px-6 py-8 sm:px-10">
          <div className="mx-auto max-w-4xl">{children}</div>
        </main>
      </div>
    </div>
  )
}
